import { displayToast, sendAppsignalError } from "../modules/utils";

class OfflineSales {
  constructor(node) {
    this.element = node;
    this.contentWrapper = this.element.querySelector(".js-offline-sales-wrapper");
    this.url = new URL(this.element.dataset.url, window.location.origin);

    this.initialize();
  }

  initialize() {
    this.setEventListener();
  }

  setEventListener() {
    this.hiddenInput = this.element.querySelector(".js-offline-sales-input");

    this.hiddenInput.addEventListener("change", (e) => {
      const { name, value } = e.target;
      this.url.searchParams.set(name, value);

      this.fetchNewData();
    });
  }

  fetchNewData() {
    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { html } = data;
        this.contentWrapper.innerHTML = html;

        window.Beyuna.initClasses(this.contentWrapper); // load all custom js

        this.setEventListener();
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "OfflineSales", {
          response: this.response,
        });
      });
  }
}

const offlineSalesElement = document.querySelector("[data-js='offline-sales']");

if (offlineSalesElement) {
  new OfflineSales(offlineSalesElement);
}
